import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Input } from "~/components/input";

import type { FormState } from "./form-state";
import { MAX, MIN } from "./settings";

export interface WidgetDecimalsProps {
	className?: string;
	disabled?: boolean;
	name: string;
	decimals: FormState;
}

export const WidgetDecimals: React.FC<WidgetDecimalsProps> = ({ className, disabled, name, decimals }) => {
	const monitor = useMonitor();

	return (
		<Input
			className={className}
			disabled={disabled}
			max={MAX}
			min={MIN}
			name={name}
			onChange={(event) => decimals.setInput(event.target.value)}
			placeholder="Auto"
			type="number"
			value={decimals.getInput(monitor)}
		/>
	);
};
